import Vue from "vue";
import { appClass } from "./modules/appClass.js";

Vue.config.productionTip = false;

Vue.prototype.$PROVIDER_SETUP_CONFIG = window.PROVIDER_SETUP_CONFIG;

new appClass();
